module.exports = __webpack_public_path__ + "static/media/SVG_Spinner.ab64b9f3.svg";